import { render } from "./QuickpayPaymentHeader.vue?vue&type=template&id=0f1a136e&scoped=true"
import script from "./QuickpayPaymentHeader.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentHeader.vue?vue&type=script&lang=js"

import "./QuickpayPaymentHeader.vue?vue&type=style&index=0&id=0f1a136e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1a136e"]])

export default __exports__